module.exports = __webpack_public_path__ + "static/media/Siroka_hora.0aafab73.md";